import React from "react";
import PageMeta from "../components/PageMeta";

export default function Terms() {
    return (
        <div className="bg-[#09090b] text-zinc-100">
            <PageMeta
                title="CGU — Sponsormania.fr | Conditions générales d'utilisation"
                description="Conditions générales d'utilisation du service Sponsormania.fr : règles de fonctionnement, droits et obligations des clubs et sponsors."
            />
            <article className="max-w-3xl mx-auto px-6 py-16 space-y-8">
                <div>
                    <div className="text-[11px] uppercase tracking-[0.25em] text-orange-500 font-bold mb-2">Utilisation</div>
                    <h1 className="font-display text-5xl uppercase tracking-tight">
                        Conditions Générales d'Utilisation
                    </h1>
                </div>

                <Section title="1. Objet">
                    <p>
                        Les présentes Conditions Générales d'Utilisation (CGU) ont pour objet de définir les modalités
                        et conditions d'utilisation du site Sponsormania.fr, ainsi que les droits et obligations des utilisateurs.
                    </p>
                </Section>

                <Section title="2. Acceptation des CGU">
                    <p>
                        L'utilisation du site implique l'acceptation pleine et entière des CGU. Si l'utilisateur
                        n'accepte pas les CGU, il doit renoncer à utiliser le site.
                    </p>
                </Section>

                <Section title="3. Création de compte">
                    <p>
                        L'inscription en tant que <strong>club</strong> ou <strong>sponsor</strong> est gratuite.
                        Chaque utilisateur s'engage à fournir des informations exactes et à jour. La validation des
                        comptes sponsors est soumise à la vérification du numéro SIREN par l'équipe Sponsormania.fr.
                    </p>
                </Section>

                <Section title="4. Service de sponsoring">
                    <p>
                        Sponsormania.fr agit en tant que place de marché entre clubs sportifs amateurs et sponsors. Le sponsor
                        choisit les emplacements de son logo sur le maillot et règle le montant correspondant. Dès
                        qu'un maillot atteint le seuil de 19€ HT cumulés, il est envoyé en production.
                    </p>
                    <p>
                        Sponsormania.fr perçoit <strong>0% de commission</strong> sur les sommes versées par les sponsors.
                    </p>
                </Section>

                <Section title="5. Paiement">
                    <p>
                        Les paiements s'effectuent par virement bancaire sur le compte BOC indiqué lors de la
                        finalisation du sponsoring. La référence fournie doit obligatoirement être indiquée dans
                        le libellé du virement.
                    </p>
                </Section>

                <Section title="6. Rétractation & remboursement">
                    <p>
                        Le sponsor dispose d'un délai de 14 jours à compter du paiement pour exercer son droit de
                        rétractation, à condition que le maillot n'ait pas encore été envoyé en production. Passé ce
                        délai ou en cas de production lancée, aucun remboursement ne pourra être effectué.
                    </p>
                </Section>

                <Section title="7. Propriété des logos">
                    <p>
                        En téléversant un logo, le sponsor garantit en détenir les droits d'exploitation et autorise
                        Sponsormania.fr à le reproduire sur les maillots du club choisi dans le cadre du sponsoring.
                    </p>
                </Section>

                <Section title="8. Modération">
                    <p>
                        Sponsormania.fr se réserve le droit de refuser, suspendre ou supprimer tout compte, annonce ou contenu
                        contraire à la loi, aux bonnes mœurs ou aux présentes CGU.
                    </p>
                </Section>

                <Section title="9. Modification des CGU">
                    <p>
                        Sponsormania.fr se réserve le droit de modifier les CGU à tout moment. Les utilisateurs seront informés
                        par email ou via le site. La poursuite de l'utilisation vaut acceptation des nouvelles CGU.
                    </p>
                </Section>

                <Section title="10. Droit applicable">
                    <p>
                        Les présentes CGU sont régies par le droit français. Tout litige sera soumis aux tribunaux
                        français compétents.
                    </p>
                </Section>

                <p className="text-xs text-zinc-500 pt-6 border-t border-zinc-800">
                    Dernière mise à jour : {new Date().toLocaleDateString("fr-FR")}.
                </p>
            </article>
        </div>
    );
}

function Section({ title, children }) {
    return (
        <section>
            <h2 className="font-display text-2xl uppercase tracking-tight text-orange-500 mb-3">{title}</h2>
            <div className="space-y-2 text-zinc-300 leading-relaxed">{children}</div>
        </section>
    );
}
